import styled, { keyframes } from 'styled-components';
import Colors from 'library/constants/colors';
import { IconBase, IconPencil } from 'library/styles/icon';
import Tag from 'library/components/tag';

const load = keyframes`
  0% {
    transform: rotate(0);
    color: ${Colors.shade08};
  }
  50% {
    transform: rotate(180deg);
    color: ${Colors.shade08};
  }
  100% {
    transform: rotate(360deg);
    color: ${Colors.shade08};
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const StyledTag = styled(Tag)`
  padding-left: 5px;
  width: auto;
  display: inline-block;
`;

export const StyledIcon = styled(IconBase)`
  font-size: 22px;
  line-height: 28px;
  cursor: pointer;
  position: relative;
  padding-left: 3px;
  
  &:before {
    margin-left: 0;
    margin-right: 0;
  }
  
  &:hover {
    color: ${Colors.shade03};
  }
`;

export const Container = styled.div`
  display: flex;
  //max-width: 638px;
  width: 100%;
  position: relative;
  flex-direction: row;
  align-items: center;
  
  input {
    //width: 1px !important;
  }
`;

export const Icon = styled(IconPencil)`
  z-index: 11;
  top: 10px;
  left: 5px;
  animation-name: ${({ isLoading }) => (isLoading ? load : '')};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;
